import { render, staticRenderFns } from "./MappingSection.vue?vue&type=template&id=a862867c"
import script from "./MappingSection.vue?vue&type=script&lang=js"
export * from "./MappingSection.vue?vue&type=script&lang=js"
import style0 from "./MappingSection.vue?vue&type=style&index=0&id=a862867c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports